import { ICheckUserRequest, ICheckUserResponse } from '../../../../lib/entity/interface/iSubscription';
import { container } from '../../../DataDomain';
import { ISubscriptionRepository } from '../../repositories/interfaces/iSubscriptionRepository';
import { DI } from '@intigral/constant/config/DIContainer';

export interface ICheckUserUseCase {
    execute(payload:ICheckUserRequest, apiToken?: { [key: string]: string }): Promise<ICheckUserResponse>;
}

export class CheckUserUseCase implements ICheckUserUseCase {
    private get subscriptionRepository(): ISubscriptionRepository {
        return container.resolve<ISubscriptionRepository>(DI.REPOSITORIES.ISubscriptionRepository);
    }

    async execute(payload:ICheckUserRequest, apiToken?: { [key: string]: string }): Promise<ICheckUserResponse> {
        return await this.subscriptionRepository.checkUser(payload, apiToken);
    }
}
